/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTYuNzUgMTMuMjVDMy43NSAxMy4yNSAxLjI1IDEwLjc1IDEuMjUgNy43NUMxLjI1IDQuNzUgMy43NSAyLjI1IDYuNzUgMi4yNUM5Ljc1IDIuMjUgMTIuMjUgNC43NSAxMi4yNSA3Ljc1SDkuNzVMMTIuNzUgMTAuNzVMMTUuNzUgNy43NUgxMy4yNUMxMy4yNSA0LjE1IDEwLjM1IDEuMjUgNi43NSAxLjI1QzMuMTUgMS4yNSAwLjI1IDQuMTUgMC4yNSA3Ljc1QzAuMjUgMTEuMzUgMy4xNSAxNC4yNSA2Ljc1IDE0LjI1VjEzLjI1WiIgZmlsbD0iaW5oZXJpdCIvPg==";